<template>
  <div :class="$vuetify.breakpoint.mdAndUp ? 'px-12 my-12' : ''" class="background-linear">
    <v-row v-if="IsAtHome" no-gutters class="font-weight-bold" align="end">
      <span>{{ $t(`mobileMenuTitle.tournaments`) }}</span>
    </v-row>
    <v-row no-gutters class="d-flex pb-2" justify="space-around" align="end">
      <v-col md="12" class="pt-0">
        <v-card-text :class="IsAtHome ? 'home-view-tournament' : ''">
          <v-row :class="IsAtHome ? 'bhagyo-no-gutters' : ''">
            <v-col :class="IsAtHome ? 'tournament-home-col' : ''">
              <v-card class="tournament-card-container index0" :class="[{ 'home-view-card-container': IsAtHome, 'homeview-full-width': IsAtHome && tournament_item.length == 1 }]">
                <!--                <div class="info-div">-->
                <!--                  <v-chip color="transparent" label x-large @click="openInfoBox">-->
                <!--                    <v-icon large left color="white" style="width:26px;">-->
                <!--                      mdi-information-outline-->
                <!--                    </v-icon>-->
                <!--                  </v-chip>-->
                <!--                </div>-->
                <v-img class="tournament-image-box" :src="`/static/image/tournaments/tournament7_${language}.jpg`" :aspect-ratio="588 / 218" contain></v-img>

                <!--                <v-col class="tournament-title pb-0">-->
                <!--                  <p class="mb-0">Neon Blaze Tournament</p>-->
                <!--                </v-col>-->
                <!--                <v-col class="tournament_spin">-->
                <!--                  <div class="tournament_slider">-->
                <!--                    <ul class="tournament_list pl-0">-->
                <!--                      <li class="tournament_listItem" v-for="(k, i) in tournament_item_0" :key="k.id">-->
                <!--                        <span>{{ k.id }}</span>-->
                <!--                        <span>{{ k.tournament_name | maskInfo }}</span>-->
                <!--                        <span>{{ k.tournament_price }}</span>-->
                <!--                        <span>{{ k.tournament_spin }}</span>-->
                <!--                      </li>-->
                <!--                    </ul>-->
                <!--                  </div>-->
                <!--                </v-col>-->
                <!--                <v-col class="pt-0 pb-0">-->
                <!--                  <div class="tournament-countdown-box">-->
                <!--                    <div class="tournament-countdown">-->
                <!--                      <v-icon small class="pr-4">schedule</v-icon>-->
                <!--                      <p class="mb-0 pl-0 tournament-countdown-text">Ending In</p>-->
                <!--                      <div class="tournament-countdown-time-box mx-3">-->
                <!--                        <p class="mb-0 tournament-countdown-time-text">{{ hours }}</p>-->
                <!--                      </div>-->
                <!--                      <p class="mb-0 pl-0 tournament-countdown-text">:</p>-->
                <!--                      <div class="tournament-countdown-time-box mx-3">-->
                <!--                        <p class="mb-0 tournament-countdown-time-text">{{ minutes }}</p>-->
                <!--                      </div>-->
                <!--                      <p class="mb-0 pl-0 tournament-countdown-text">:</p>-->
                <!--                      <div class="tournament-countdown-time-box mx-3">-->
                <!--                        <p class="mb-0 tournament-countdown-time-text">{{ seconds }}</p>-->
                <!--                      </div>-->
                <!--                    </div>-->
                <!--                  </div>-->
                <!--                </v-col>-->
                <!--                <v-col class="tournament-button-box">-->
                <!--                  <div class="tournament-button">-->
                <!--&lt;!&ndash;                    <v-btn class="full-width pa-2 primary-button theme&#45;&#45;light mobile-apply-btn">{{ $t(`label.applyNow`) }}</v-btn>&ndash;&gt;-->
                <!--&lt;!&ndash;                    <v-btn text class="tournament-detail-btn primary-button pa-2 " @click="openTournamentHtml(1)">{{ $t(`button.details`) }}</v-btn>&ndash;&gt;-->
                <!--                  </div>-->
                <!--                </v-col>-->
              </v-card>
            </v-col>
          </v-row>

          <!--          <v-row :class="IsAtHome ? 'bhagyo-no-gutters' : ''">-->
          <!--            <v-col :class="IsAtHome ? 'tournament-home-col' : ''">-->
          <!--              <v-card class="tournament-card-container" :class="IsAtHome ? 'home-view-card-container' : ''">-->
          <!--                <div class="info-div">-->
          <!--                  <v-chip color="transparent" label x-large @click="openInfoBox">-->
          <!--                    <v-icon large left color="white" style="width:26px;">-->
          <!--                      mdi-information-outline-->
          <!--                    </v-icon>-->
          <!--                  </v-chip>-->
          <!--                </div>-->
          <!--                <v-col>-->
          <!--                  <v-img class="tournament-image-box" :src="`/static/image/tournaments/luckyClucks.png`" contain></v-img>-->
          <!--                </v-col>-->
          <!--                <v-col class="tournament-title pb-0">-->
          <!--                  <p class="mb-0">Neon Blaze Tournament</p>-->
          <!--                </v-col>-->
          <!--                <v-col class="tournament_spin">-->
          <!--                  <div class="tournament_slider">-->
          <!--                    <ul class="tournament_list pl-0">-->
          <!--                      <li class="tournament_listItem" v-for="(k, i) in tournament_item" :key="k.id">-->
          <!--                        <span>{{ k.id }}</span>-->
          <!--                        <span>{{ k.tournament_name | maskInfo }}</span>-->
          <!--                        <span>{{ k.tournament_price }}</span>-->
          <!--                        <span>{{ k.tournament_spin }}</span>-->
          <!--                      </li>-->
          <!--                    </ul>-->
          <!--                  </div>-->
          <!--                </v-col>-->
          <!--                <v-col class="pt-0 pb-0">-->
          <!--                  <div class="tournament-countdown-box">-->
          <!--                    <div class="tournament-countdown">-->
          <!--                      <v-icon small class="pr-4">schedule</v-icon>-->
          <!--                      <p class="mb-0 pl-0 tournament-countdown-text">Ending In</p>-->
          <!--                      <div class="tournament-countdown-time-box mx-3">-->
          <!--                        <p class="mb-0 tournament-countdown-time-text">{{ hours }}</p>-->
          <!--                      </div>-->
          <!--                      <p class="mb-0 pl-0 tournament-countdown-text">:</p>-->
          <!--                      <div class="tournament-countdown-time-box mx-3">-->
          <!--                        <p class="mb-0 tournament-countdown-time-text">{{ minutes }}</p>-->
          <!--                      </div>-->
          <!--                      <p class="mb-0 pl-0 tournament-countdown-text">:</p>-->
          <!--                      <div class="tournament-countdown-time-box mx-3">-->
          <!--                        <p class="mb-0 tournament-countdown-time-text">{{ seconds }}</p>-->
          <!--                      </div>-->
          <!--                    </div>-->
          <!--                  </div>-->
          <!--                </v-col>-->
          <!--                <v-col class="tournament-button-box">-->
          <!--                  <div class="tournament-button">-->
          <!--                    <v-btn class="full-width pa-2 primary-button theme&#45;&#45;light mobile-apply-btn">{{ $t(`label.applyNow`) }}</v-btn>-->
          <!--                    <v-btn text class="primary-button pa-2 white&#45;&#45;text mobile-detail-btn text-decoration-underline">{{ $t(`button.details`) }}</v-btn>-->
          <!--                  </div>-->
          <!--                </v-col>-->
          <!--              </v-card>-->
          <!--            </v-col>-->
          <!--          </v-row>-->
          <!--          <v-row :class="IsAtHome ? 'bhagyo-no-gutters' : ''">-->
          <!--            <v-col :class="IsAtHome ? 'tournament-home-col' : ''">-->
          <!--              <v-card class="tournament-card-container index2" :class="IsAtHome ? 'home-view-card-container' : ''">-->
          <!--                <div class="info-div">-->
          <!--                  <v-chip color="transparent" label x-large @click="openInfoBox">-->
          <!--                    <v-icon large left color="white" style="width:26px;">-->
          <!--                      mdi-information-outline-->
          <!--                    </v-icon>-->
          <!--                  </v-chip>-->
          <!--                </div>-->
          <!--                <v-col>-->
          <!--                  <v-img class="tournament-image-box" :src="`/static/image/tournaments/luckyClucks.png`" contain></v-img>-->
          <!--                </v-col>-->
          <!--                <v-col class="tournament-title pb-0">-->
          <!--                  <p class="mb-0">Neon Blaze Tournament</p>-->
          <!--                </v-col>-->
          <!--                <v-col class="tournament_spin">-->
          <!--                  <div class="tournament_slider">-->
          <!--                    <ul class="tournament_list pl-0">-->
          <!--                      <li class="tournament_listItem" v-for="(k, i) in tournament_item_2" :key="k.id">-->
          <!--                        <span>{{ k.id }}</span>-->
          <!--                        <span>{{ k.tournament_name | maskInfo }}</span>-->
          <!--                        <span>{{ k.tournament_price }}</span>-->
          <!--                        <span>{{ k.tournament_spin }}</span>-->
          <!--                      </li>-->
          <!--                    </ul>-->
          <!--                  </div>-->
          <!--                </v-col>-->
          <!--                <v-col class="pt-0 pb-0">-->
          <!--                  <div class="tournament-countdown-box">-->
          <!--                    <div class="tournament-countdown">-->
          <!--                      <v-icon small class="pr-4">schedule</v-icon>-->
          <!--                      <p class="mb-0 pl-0 tournament-countdown-text">Ending In</p>-->
          <!--                      <div class="tournament-countdown-time-box mx-3">-->
          <!--                        <p class="mb-0 tournament-countdown-time-text">{{ hours }}</p>-->
          <!--                      </div>-->
          <!--                      <p class="mb-0 pl-0 tournament-countdown-text">:</p>-->
          <!--                      <div class="tournament-countdown-time-box mx-3">-->
          <!--                        <p class="mb-0 tournament-countdown-time-text">{{ minutes }}</p>-->
          <!--                      </div>-->
          <!--                      <p class="mb-0 pl-0 tournament-countdown-text">:</p>-->
          <!--                      <div class="tournament-countdown-time-box mx-3">-->
          <!--                        <p class="mb-0 tournament-countdown-time-text">{{ seconds }}</p>-->
          <!--                      </div>-->
          <!--                    </div>-->
          <!--                  </div>-->
          <!--                </v-col>-->
          <!--                <v-col class="tournament-button-box">-->
          <!--                  <div class="tournament-button">-->
          <!--                    <v-btn class="full-width pa-2 primary-button theme&#45;&#45;light mobile-apply-btn">{{ $t(`label.applyNow`) }}</v-btn>-->
          <!--                    <v-btn text class="primary-button pa-2 white&#45;&#45;text mobile-detail-btn text-decoration-underline">{{ $t(`button.details`) }}</v-btn>-->
          <!--                  </div>-->
          <!--                </v-col>-->
          <!--              </v-card>-->
          <!--            </v-col>-->
          <!--          </v-row>-->
        </v-card-text>
      </v-col>
    </v-row>
    <app-seo-content v-if="!IsAtHome"></app-seo-content>
    <app-dialog class="pop_box" custom-class="tournament-detail-popup" :max-width="500" :dialog-show="tournamentDetails" :title="tournamentPopUpTitle" :close-action="this.closeDetailsBox">
      <v-container class="fill-height">
        <iframe class="details-iframe" :src="tournamentURL" frameborder="0"></iframe>
      </v-container>
    </app-dialog>
  </div>
</template>
<script>
import { CACHE_KEY, SHARED } from '@/constants/constants'
import { locale, uiHelper } from '@/util'
import maskSensitiveInfo from '@/filters/mask-sensitive-info'
import { ROUTE_NAME } from '@/constants/route.constants'
import AppSeoContent from '@/components/layout/SEOContent.vue'

export default {
  name: 'Tournament',
  components: { AppSeoContent },
  data: () => ({
    tournamentURL: '',
    language: uiHelper.getLanguage(),
    pageDialog: {
      title: 'lucky cluck info',
      closePageDialog: () => {
        this.informationBox = false
      },
      messageTitle: '',
      message: [],
      button: [
        {
          title: locale.getMessage(`label.close`),
          action: () => {
            this.informationBox = false
          }
        }
      ]
    },
    tournamentDetails: false,
    tournamentPopUpTitle: '',
    maskFormatter: maskSensitiveInfo,
    tournament_item: [
      {
        id: 1,
        tournament_name: 'Mega Free Spin'
      }
    ],
    tournament_item_0: [
      {
        id: 1,
        tournament_name: 'Toti001',
        tournament_price: 720,
        tournament_spin: 500
      },
      {
        id: 2,
        tournament_name: 'kim001',
        tournament_price: 720,
        tournament_spin: 500
      },
      {
        id: 3,
        tournament_name: 'calvin002',
        tournament_price: 720,
        tournament_spin: 500
      },
      {
        id: 4,
        tournament_name: 'jack001',
        tournament_price: 720,
        tournament_spin: 500
      },
      {
        id: 5,
        tournament_name: 'kenny001',
        tournament_price: 720,
        tournament_spin: 500
      }
    ],
    tournament_item_2: [
      {
        id: 1,
        tournament_name: 'yo001',
        tournament_price: 220,
        tournament_spin: 500
      },
      {
        id: 2,
        tournament_name: 'jeffrey001',
        tournament_price: 30,
        tournament_spin: 500
      },
      {
        id: 3,
        tournament_name: 'tam002',
        tournament_price: 720,
        tournament_spin: 500
      },
      {
        id: 4,
        tournament_name: 'yoyoTan001',
        tournament_price: 880,
        tournament_spin: 500
      },
      {
        id: 5,
        tournament_name: 'kenny001',
        tournament_price: 688,
        tournament_spin: 500
      }
    ],
    endDate: 1671882412687000000000000,
    isEnded: false,
    hours: 24,
    minutes: 10,
    seconds: 10
  }),
  created() {
    if (!this.IsAtHome) {
      this.metaTag()
    }
  },
  computed: {
    IsAtHome() {
      return this.$route.name == ROUTE_NAME.HOME
    }
  },
  methods: {
    metaTag() {
      uiHelper.setTitle(`${locale.getMessage('meta.tournament_title')}`)
      uiHelper.setMetaTag('description', `${locale.getMessage('meta.tournament_description')}`)
    },
    openTournamentHtml(sequence) {
      let tournament_1 = {
        title: locale.getMessage('label.tournamentTitle')
      }
      this.tournamentURL = `${process.env.BASE_URL}static/html/other/${uiHelper.getLanguage()}/tournament${sequence}.html`
      this.tournamentDetails = true
      this.tournamentPopUpTitle = tournament_1.title
    },
    openDetailsBox() {
      this.tournamentDetails = true
    },
    closeDetailsBox() {
      this.tournamentDetails = false
    },
    tick() {
      const currentTime = new Date().getTime()
      const distance = Math.max(this.endDate - currentTime, 0)
      this.countdownTime(distance)

      if (distance === 0) {
        clearInterval(this.timer)
        this.isEnded = true
      }
    },
    countdownTime(distance) {
      // Time calculations for days, hours, minutes and seconds
      this.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      this.seconds = Math.floor((distance % (1000 * 60)) / 1000)
    }
  }
}
</script>
<style lang="scss">
.tournament-detail-popup {
  padding: 0;
}
.details-iframe {
  width: 100%;
  height: 500px;
}
.tournament-detail-btn {
  width: 100% !important;
  background-color: var(--v-newMobileSecondary-base) !important;
  color: #000000 !important;
}
.home-view-tournament {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  flex-wrap: nowrap;
  padding: 0px !important;
  gap: 0px 16px;
}
.bhagyo-no-gutters {
  margin: 0 !important;
}
.tournament-home-col {
  padding: 0 !important;
}
.pop_box {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 99999;
}
.mobile-apply-btn {
  width: 112px !important;
  height: 35px !important;
  font-size: 16px !important;
  background-color: inherit;
}

.tournament-card-container {
  width: 366px;
  margin-left: auto !important;
  margin-right: auto !important;
  margin-bottom: 20px;

  border-radius: 12px !important;
  &.home-view-card-container {
    width: 280px !important;
  }
  &.home-view-card-container.homeview-full-width {
    width: 100% !important;
  }
  &.index2 {
    background: radial-gradient(94.2% 94.2% at 11.78% 5.8%, #58d13a 0%, #14656a 100%) !important;
  }
  &.index0 {
    background-color: #333;
  }

  .info-div {
    position: absolute;
    right: 0;
    z-index: 99999;
  }
  .tournament-image-box {
    border-top-right-radius: inherit;
    border-top-left-radius: inherit;
  }

  .tournament-title {
    color: #ffffff;
    font-size: 14px;
    text-align: center;
  }

  .tournament_spin {
    position: relative;
    width: 100%;

    .tournament_wrap {
      padding: 4vw;
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }

    .tournament_wrap:after,
    .tournament_wrap:before {
      left: 50%;
      z-index: 1;
    }

    .tournament_slider {
      display: flex;
      overflow: hidden;
      height: 80px;

      width: 100%;
      margin-left: auto;
      margin-right: auto;
    }

    .tournament_list {
      flex: 0 0 100%;
      overflow: auto;
      position: relative;
      transition: left 0.4s;
    }

    .tournament_listItem {
      display: flex;
      font-size: 10px;
      justify-content: space-between;
      line-height: 22px;
      padding: 0 6%;
      color: #ffffff;
      border-bottom: 0.5px solid rgba(255, 255, 255, 0.48);
      height: 25px;
    }
  }

  .tournament-countdown-box {
    border-radius: 8px;
    //width: 310px;
    height: 32px;
    background: rgba(255, 255, 255, 0.12);
    margin-left: auto;
    margin-right: auto;

    .tournament-countdown {
      display: flex;
      line-height: 30px;
      text-align: center;
      align-items: center;
      padding-top: 1px;
      padding-bottom: 1px;
      justify-content: center;
      .tournament-countdown-text {
        font-size: 12px;
        color: #ffffff;
      }

      .tournament-countdown-time-box {
        width: 28px;
        height: 24px;
        background: rgba(255, 255, 255, 0.12);
        border-radius: 4px;
        text-align: center;
      }

      .tournament-countdown-time-text {
        font-size: 10px;
        height: 0;
        margin: -2px;
        color: #ffffff;
      }
    }
  }

  .tournament-button-box {
    display: flex;

    .tournament-button {
      width: 100%;
      margin-right: auto;
      margin-left: auto;
    }
  }
}
</style>
